import React from 'react'
import { getCatalogTaxonomyStatusLines } from './getCatalogTaxonomyStatusLine'
import styles from './CatalogTaxonomyStatusLine.module.scss'

function CatalogTaxonomyStatusLine({ node, ancestors = [], includeAncestorHiddenNav = false }) {
  const statusLines = getCatalogTaxonomyStatusLines(node, ancestors, { includeAncestorHiddenNav })
  if (!statusLines.length) return null

  return (
    <div className={styles.row}>
      {statusLines.map((statusLine) => (
        <p key={statusLine.label} className={styles.status}>
          <span className={styles.mark} style={{ background: statusLine.markColor }} />
          {statusLine.label}
        </p>
      ))}
    </div>
  )
}

export default CatalogTaxonomyStatusLine
